import React from "react";

import ColorControl from "../ui/ColorControl";

export default function HatchingControls({
  Slider,

  inkColor,
  setInkColor,

  hatchScale,
  setHatchScale,
}) {
  return (
    <>
      <ColorControl label="Ink Color" value={inkColor} onChange={setInkColor} />

      <Slider
        label="Hatch Scale"
        value={hatchScale}
        min={0.5}
        max={10}
        step={0.05}
        display={hatchScale.toFixed(2)}
        onChange={setHatchScale}
      />
    </>
  );
}
